import { useEffect, useState } from 'react';
import { DEFAULT_TEMPLATE_VISIBILITY_VALUE } from '../../pages/ManageTemplates/pages/constants.ts';

interface TemplateWithVisibility {
  visibility?: TemplateVisibilityValues;
}

interface UseVisibilityFilterProps<T extends TemplateWithVisibility> {
  templates: T[];
  visibilityFilters: TemplateVisibilityValues[];
}

export function useVisibilityFilter<T extends TemplateWithVisibility>({
  templates,
  visibilityFilters,
}: UseVisibilityFilterProps<T>): T[] {
  const [filteredTemplates, setFilteredTemplates] = useState<T[]>(templates);

  useEffect(() => {
    if (visibilityFilters.length === 0) {
      setFilteredTemplates([]);
    } else {
      const filtered = templates.filter(
        ({ visibility = DEFAULT_TEMPLATE_VISIBILITY_VALUE }) =>
          visibilityFilters.includes(visibility),
      );
      setFilteredTemplates(filtered);
    }
  }, [templates, visibilityFilters]);

  return filteredTemplates;
}
